export class EntityActions {
  static readonly ADD_ENTITIES = 'receiver/entity/ADD_ENTITIES';
}

export class PaycodeAttemptActions {
  static readonly LOAD_REQUEST = 'receiver/paycodeattempt/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'receiver/paycodeattempt/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'receiver/paycodeattempt/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'receiver/paycodeattempt/LOAD_LIST_SUCCESS';

  static readonly SET_CURRENT_PAGE = 'receiver/paycodeattempt/SET_CURRENT_PAGE';
}
